import * as React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Button, Col, Divider, message, Row, Upload, Spin, Alert, notification } from 'antd';
import { UploadOutlined, LoadingOutlined, DownloadOutlined } from '@ant-design/icons';
import { Title } from '../../components/Layout/components';
import { attachmentUrl, url } from '../../config/config';
import { callAuthorizeBackend } from 'src/helpers/Backend/callAuthorizeBackend';

interface IVouchersImportExportProps extends RouteComponentProps<{
  eshop: string,
  groupId: string;
}> {
  voucherGroup: any;
}

interface IVouchersImportExporttate {
  redirectBack: boolean;
  exportLoading: boolean;
}

class VouchersImportExport extends React.Component<IVouchersImportExportProps, IVouchersImportExporttate> {

  public constructor(props: IVouchersImportExportProps) {
    super(props);

    this.state = {
      redirectBack: false,
      exportLoading: false,
    };

    this.exportAllVouchers = this.exportAllVouchers.bind(this);
  }

  public render() {
    const { eshop, groupId } = this.props.match.params;

    const props = {
      name: 'file',
      accept: '.csv',
      action: `${attachmentUrl}/import-vouchers/?voucherGroupId=${groupId}`,
      showUploadList: false,
      onChange: (info: any) => {
        if (info.file.status === 'done') {
          message.success(`Vouchers has been imported!`);
        } else if (info.file.status === 'error') {
          message.error(`Vouchers import failed.`);
        }
      },
    };

    if (this.state.redirectBack) {
      return (<Redirect to={`/${eshop}/application/vouchers/${groupId}`} />);
    }

    return (
      <Query
        query={GetVoucherGroup}
        variables={{
          voucherGroupId: this.props.match.params.groupId
        }}
      >
        {({ data: { loading, error, data } }) => {
          return (
            <>
              <Row>
                <Col span={24}>
                  <Title>Import vouchers</Title>
                  <Divider />
                  <div style={{ marginBottom: '4rem' }}>
                    {loading === true
                      && <Spin />}
                    {loading === false && data && data.voucherGroup &&
                      <>
                        <div style={{ paddingBottom: 20 }}>
                          <a href={`${url}/vouchers/import-template`}>Sample file</a> for import vouchers
                        </div>
                        <Upload {...props}>
                          <Button>
                            <UploadOutlined /> Import
                          </Button>
                        </Upload>
                        <Divider type={'vertical'} />
                        <Button onClick={() => this.backToList()}>Back</Button>
                      </>}
                    {error &&
                      <Alert
                        type={'error'}
                        message={'Voucher group not found'}
                      />}
                  </div>

                  <Title>Export vouchers</Title>
                  <Divider />
                  <div>
                    <Button onClick={() => this.exportAllVouchers(false)}>
                      {this.state.exportLoading === true ? <LoadingOutlined /> : <DownloadOutlined />} Export all vouchers of voucher group
                    </Button>
                    <Divider type={'vertical'} />
                    <Button onClick={() => this.exportAllVouchers(true)}>
                      {this.state.exportLoading === true ? <LoadingOutlined /> : <DownloadOutlined />} Export last imported vouchers
                    </Button>
                    <Divider type={'vertical'} />
                    <Button onClick={() => this.backToList()}>Back</Button>
                  </div>

                </Col>
              </Row>
            </>
          );
        }}
      </Query>
    );
  }

  private backToList() {
    this.setState({
      redirectBack: true,
    });
  }

  private exportAllVouchers(exportLast: boolean = false) {
    this.setState({
      exportLoading: true,
    }, () => {

      callAuthorizeBackend({
        path: '/vouchers/export',
        data: {
          voucherGroupId: this.props.match.params.groupId,
          last: exportLast,
        },
        executeDownload: true,
        onSuccess: () => {
          notification['success']({
            message: 'Info',
            description: `Invoices exported!`
          });

          this.setState({
            exportLoading: false
          });
        },
        onError: (err: any) => {
          notification['error']({
            message: 'Info',
            description: `Invoices export failed!`
          });

          this.setState({
            exportLoading: false
          });
        }
      });
    });
  }
}

const GetVoucherGroup = gql`
  query voucherGroup($voucherGroupId: String!) {
    voucherGroup(voucherGroupId: $voucherGroupId) {
      id
      active
      title
      source
      type
      amount
    }
  }
`;

export default VouchersImportExport;


// WEBPACK FOOTER //
// ./src/scenes/VouchersImportExport/VouchersImportExport.tsx